import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { resetFiltersSlice, noFiltersSelector } from '../filtersSlice';

/** хук сбрасывает в `filterSlice` все данные на начальные */
export const useResetFilters = () => {
  const dispatch = useDispatch();
  const disabledReset = useSelector(noFiltersSelector);

  const onClickReset = React.useCallback(() => {
    dispatch(resetFiltersSlice());
  }, [dispatch]);
  return { disabledReset, onClickReset };
};
